export function FeatureItem({
  icon: Icon,
  title,
  description,
  showDivider = false,
  light = false
}) {
  if (light) {
    // Matches the Socure / payment-account "Before You Start" pattern exactly
    return (
      <div className="flex gap-3 items-start">
        <span className="shrink-0 w-10 h-10 rounded-full bg-secondary-light flex items-center justify-center">
          <Icon className="w-5 h-5 text-secondary" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-base-content">{title}</p>
          <p className="text-sm text-muted font-light">{description}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center gap-3 py-4 first:pt-0 last:pb-0">
        <div
          className="shrink-0 w-9 h-9 md:w-8 md:h-8 rounded-full flex items-center justify-center"
          style={{
            background: 'linear-gradient(180deg, #082F5D 0%, #355588 100%)'
          }}
        >
          <Icon className="w-5 h-5 md:w-6 md:h-6 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-base-content text-sm md:text-sm">{title}</p>
          <p className="text-base-content text-xs md:text-sm font-light">
            {description}
          </p>
        </div>
      </div>
      {showDivider && <div className="border-t border-slate-blue-300"></div>}
    </>
  );
}
